import { useBranding } from '@/lib/branding'

export function OnboardingFooter() {
  const { display_name, legal_name, support_url } = useBranding()

  const year = new Date().getFullYear()

  return (
    <footer className="mt-16 border-t border-border bg-muted/30 px-6 py-6 text-xs text-muted-fg">
      <div className="mx-auto flex max-w-4xl flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <span>
          &copy; {year} {legal_name || display_name}. All rights reserved.
        </span>
        <div className="flex items-center gap-4">
          {support_url ? (
            <a
              href={support_url}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-fg hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:rounded"
            >
              Support
            </a>
          ) : null}
          <a
            href="/login"
            className="hover:text-fg hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:rounded"
          >
            Operator Console
          </a>
        </div>
      </div>
    </footer>
  )
}
